import type { ReactNode } from 'react';

export const symbol_airplane_ticket: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m479-438-111 31-45-38q-1-1-15-2l-4 1q-7 2-9.5 9t.5 13l47 88q2 5 7.5 7.5t10.5.5l356-98q17-5 25-16t3-28q-5-17-18-23.5t-28.8-2.37L594-469 438.23-620.59Q433-626 426.67-628q-6.34-2-12.67 0l-4.74 1q-13.26 3-17.76 15-4.5 12 1.5 23l86 151ZM140-160q-24.75 0-42.37-17.63Q80-195.25 80-220v-132q0-10.19 5.5-17.59Q91-377 100-380q31-11 48.5-39.5t17.5-60q0-31.5-17.5-60.5T100-580q-9-3-14.5-10.41Q80-597.81 80-608v-132q0-24.75 17.63-42.38Q115.25-800 140-800h680q24.75 0 42.38 17.62Q880-764.75 880-740v520q0 24.75-17.62 42.37Q844.75-160 820-160H140Zm0-60h680v-520H140v109q39 26 62.5 65t23.5 86q0 47-23.5 86T140-329v109Zm340-260Z"
		/>
	</svg>
);
